// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AaJu","questions":"styles_questions__3gwNI","footer":"styles_footer__35v4N"};